<template>
    <el-input
        v-model="localValue"
    >
    </el-input>
</template>
<script>
    import CfMixin from 'mixins/CustomfieldsMixins';

    export default {
        mixins: [CfMixin],

        computed: {
            localValue: {
                get() {
                    return this.value;
                },
                set(value) {
                    if(!isNaN(value)) this.$emit('input', { id: this.id, value });
                }
            }
        },
    }
</script>
